import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CasosExitoComponent } from './pages/casos-exito/casos-exito.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { CasosExitoListingBlockComponent } from './components/casos-exito-listing-block/casos-exito-listing-block.component';
import { CasoComponent } from './pages/caso/caso.component';



@NgModule({
  declarations: [
    CasosExitoComponent,
    CasosExitoListingBlockComponent,
    CasoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ]
})
export class CasosExitoModule { }
